import { Injectable } from '@angular/core';

import { SessionStorageService } from '../../../../core';

import { RepresentanteVisualizacao } from './representante-visualizacao';

/**
 * Service utilizado para armazenar os dados de visualização dos representantes no session storage do navegador
 */
@Injectable({
    providedIn: 'root'
})
export class RepresentanteVisualizacaoStorageService {
    constructor(private sessionStorageService: SessionStorageService) { }

    /** Obtem o storage da visualização de representantes no Session Storage do navegador */
    get(key: string): RepresentanteVisualizacao {
        const storage = this.sessionStorageService.getObject(key);
        if (!storage) {
            return new RepresentanteVisualizacao();
        }
        return storage as RepresentanteVisualizacao;
    }

    /** Seta o storage da visualização de representantes no Session Storage do navegador */
    set(key: string, storage: RepresentanteVisualizacao) {
        this.sessionStorageService.setObject(key, storage);
    }

    /** Remove o storage da visualização de representantes no Session Storage do navegador */
    remove(key: string) {
        this.sessionStorageService.remove(key);
    }
}
